import React from "react";
import { Box, Divider, Flex } from "@chakra-ui/react";
import Header from "./Header";
import Body from "./Body";
import Footer from "./Footer";
const FormConfiguration = () => {
  return (
    <Box
      bg="#FFFFFF"
      borderRadius="4px"
      borderColor="#CFD7DF"
      borderStyle="
		solid"
      m="16px auto 4px"
      w="680px"
      p="40px"
      minH="634px"
      color="#12344D"
    >
      {/* header */}
      <Header />
      {/* body */}
      <Body />
      <Divider mt="24px" mb="24px" w="600px" />
      {/* footer */}
      <Footer />
    </Box>
  );
};

export default FormConfiguration;
